export default class FileRepository {
  public static readonly EVENT_UPLOAD_SUCCESS = 'recordFiles:iploadSuccess';
}
